import React, { useState } from 'react';
import { Route } from 'react-router';

import { MemberRoute } from '@swf/core/types/Poker';
import { useGetContentRoutes } from '@swf/poker';

import Approved from './Approved/Approved';
import Blocked from './Blocked/Blocked';
import type { MembersContextState } from './MembersContext/MembersContext';
import MembersContext from './MembersContext/MembersContext';
import Pending from './Pending/Pending';
import Tabs from './Tabs/Tabs';

const Content: React.FC = () => {
  const { clubsPath } = useGetContentRoutes();

  return (
    <>
      <Tabs />
      <Route path={`${clubsPath}/:clubId/:section/${MemberRoute.List}`} component={Approved} />
      <Route path={`${clubsPath}/:clubId/:section/${MemberRoute.Pending}`} component={Pending} />
      <Route path={`${clubsPath}/:clubId/:section/${MemberRoute.Blocked}`} component={Blocked} />
    </>
  );
};

const MembersContainer: React.FC = () => {
  const [state, setState] = useState<MembersContextState>({
    members: [],
    loading: true
  });

  return (
    <MembersContext.Provider value={{ setState, state }}>
      <Content />
    </MembersContext.Provider>
  );
};

export default MembersContainer;
